// Shared chrome for every small floating panel on the Tasks screen (status
// picker, filter bar, sort menu) so they read as one family of popovers
// instead of three near-identical hand-rolled ones.
export const TASK_POPOVER_PANEL_CLASS =
  'rounded-xl border border-n-weak bg-n-alpha-3 backdrop-blur-[100px] shadow-lg';
